import React from "react";
import { ContentCodeProvider } from "./ContentCodeProvider";
import { CashCodeProvider } from "./CashCodeProvider";

export type ProviderType = "contentCode" | "cashCode";

export type PluginProvidersProps = {
  children: React.ReactNode;
  providers: ProviderType[];
};

// new providers can be added to this array
const providerComponents = {
  cashCode: CashCodeProvider,
  contentCode: ContentCodeProvider,
};

export const PluginProviders = ({ children, providers = [] }: PluginProvidersProps) => {
  const components = React.useMemo(() => {
    const list: React.FC<{ children: React.ReactNode }>[] = [];

    providers.forEach((provider) => {
      list.push(providerComponents[provider]);
    });

    return list;
  }, [providers]);

  return (
    <>
      {components.reduceRight((acc, Comp) => {
        return <Comp>{acc}</Comp>;
      }, children)}
    </>
  );
};
